import { memo } from 'react';
import { Skeleton } from '@mantine/core';
import clsx from 'clsx';

import classes from './StatCardSkeleton.module.css';

interface StatCardSkeletonProps {
  readonly compact?: boolean;
  readonly className?: string;
}

/**
 * Skeleton placeholder matching KpiCard layout.
 * Top row: label text + icon box. Bottom row: value + percentage badge.
 */
export const StatCardSkeleton = memo(function StatCardSkeleton({
  compact = false,
  className,
}: StatCardSkeletonProps) {
  const iconSize = compact ? 26 : 32;

  return (
    <div
      className={clsx(classes.card, compact && classes.compact, className)}
      role="status"
      aria-busy="true"
    >
      <div className={classes.topRow}>
        <Skeleton height={12} width="40%" radius="sm" />
        <Skeleton height={iconSize} width={iconSize} radius="md" />
      </div>
      <div className={classes.bottomRow}>
        <Skeleton height={compact ? 20 : 28} width={60} radius="sm" />
        <Skeleton height={18} width={36} radius="xl" />
      </div>
    </div>
  );
});

StatCardSkeleton.displayName = 'StatCardSkeleton';
